<template>
	<div class="h-screen flex flex-col items-center justify-center h-full">
		<img
			src="@/assets/gato_duda.svg"
			alt="Gato Duda"
			class="w-48 mb-8"
		/>
		<div class="text-3xl">404</div>
		<p>Lo sentimos, la página que buscas no existe.</p>
		<router-link
			to="/"
			class="home-link"
		>
			<button class="bg-accent-green text-white px-4 py-2 rounded-full mt-4 px-4">
				Volver al inicio
			</button>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'NotFoundView'
}
</script>
